var map = {
	"./en.json": 1039,
	"./es.json": 1040
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1038;


//////////////////
// WEBPACK FOOTER
// ./static/locales [A-Za-z0-9-_,\s]+\.json$/
// module id = 1038
// module chunks = 43